// RangerAvatar - renders a child's pre-generated avatar from their avatar_config.
// config: { skin, outfit, companion }. Images live in /public/avatars.

const DEFAULTS = { skin: 'light', outfit: 'classic', companion: 'none' };

export const charImage = (config) => {
    const c = config || {};
    const outfit = c.outfit || DEFAULTS.outfit;
    const skin = c.skin || DEFAULTS.skin;
    return `/avatars/char/${outfit}__${skin}.png`;
};

export const companionImage = (companionId) =>
    companionId && companionId !== 'none' ? `/avatars/companions/${companionId}.png` : null;

export const RangerAvatar = ({
    config,
    variant = 'full', // 'full' | 'badge'
    showCompanion = true,
    className = '',
    'data-testid': testId,
}) => {
    const c = config || DEFAULTS;
    const charUrl = charImage(c);
    const compUrl = companionImage(c.companion);

    if (variant === 'badge') {
        return (
            <div className={`relative overflow-hidden bg-white ${className}`} data-testid={testId}>
                <img
                    src={charUrl}
                    alt="Ranger"
                    className="w-full h-full object-cover object-top scale-[1.15]"
                    onError={(e) => { e.target.src = '/avatars/char/classic__light.png'; }}
                />
            </div>
        );
    }

    return (
        <div className={`relative w-full h-full ${className}`} data-testid={testId}>
            <img
                src={charUrl}
                alt="Your Ranger"
                className="w-full h-full object-contain"
                onError={(e) => { e.target.src = '/avatars/char/classic__light.png'; }}
            />
            {showCompanion && compUrl && (
                <img
                    src={compUrl}
                    alt="Buddy"
                    className="absolute bottom-1 right-1 w-[26%] h-[26%] object-contain"
                />
            )}
        </div>
    );
};

export default RangerAvatar;
